import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
import FunctionInputOutput from './FunctionInputOutput';
import FunctionParameters from './FunctionParameters';

var FunctionDefinition = /*#__PURE__*/function () {
  function FunctionDefinition(functionObj) {
    this._extendedDescription = functionObj.extendedDescription;
    this._displayName = functionObj.displayName;
    this._functionGroup = functionObj.functionGroup;
    this._example = functionObj.example;
    this._output = new FunctionInputOutput(functionObj.output);
    this._input = functionObj.input.map(function (input) {
      return new FunctionInputOutput(input);
    });
    this._displayOnly = functionObj.displayOnly;
    this._name = functionObj.name;
    this._description = functionObj.description;
    this._type = functionObj.type;
    this._shortName = functionObj.shortName;
    this._helpResourceURI = functionObj.helpResourceURI;
    this._parameters = functionObj.parameters.map(function (param) {
      return new FunctionParameters(param);
    });
  }

  _createClass(FunctionDefinition, [{
    key: 'output',
    get: function get() {
      return this._output;
    },
    set: function set(val) {
      this._output = val;
    }
  }, {
    key: 'input',
    get: function get() {
      return this._input;
    },
    set: function set(val) {
      this._input = val;
    }
  }, {
    key: 'displayOnly',
    get: function get() {
      return this._displayOnly;
    },
    set: function set(val) {
      this._displayOnly = val;
    }
  }, {
    key: 'name',
    get: function get() {
      return this._name;
    },
    set: function set(val) {
      this._name = val;
    }
  }, {
    key: 'description',
    get: function get() {
      return this._description;
    },
    set: function set(val) {
      this._description = val;
    }
  }, {
    key: 'type',
    get: function get() {
      return this._type;
    },
    set: function set(val) {
      this._type = val;
    }
  }, {
    key: 'shortName',
    get: function get() {
      return this._shortName;
    },
    set: function set(val) {
      this._shortName = val;
    }
  }, {
    key: 'helpResourceURI',
    get: function get() {
      return this._helpResourceURI;
    },
    set: function set(val) {
      this._helpResourceURI = val;
    }
  }, {
    key: 'parameters',
    get: function get() {
      return this._parameters;
    },
    set: function set(val) {
      this._parameters = val;
    }
  }, {
    key: 'extendedDescription',
    get: function get() {
      return this._extendedDescription;
    },
    set: function set(val) {
      this._extendedDescription = val;
    }
  }, {
    key: 'displayName',
    get: function get() {
      return this._displayName;
    },
    set: function set(val) {
      this._displayName = val;
    }
  }, {
    key: 'functionGroup',
    get: function get() {
      return this._functionGroup;
    },
    set: function set(val) {
      this._functionGroup = val;
    }
  }, {
    key: 'example',
    get: function get() {
      return this._example;
    },
    set: function set(val) {
      this._example = val;
    }
  }]);

  return FunctionDefinition;
}();

export { FunctionDefinition as default };